// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.campaign.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttCampaign from "./campaign";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

// campaignSearch lives in its own module so it is the single source of truth:
// rembrandt's cross-layer AI-behavior contract tests read campaignSearch.ts
// directly (services/rembrandt/tests/test_review_agent.py,
// test_review_service_run.py) to assert the FE chatId normalization the review
// pipeline depends on. Re-exported here so existing
// `import { campaignSearch } from "./campaignRoute"` call sites keep working
// without the file diverging from a second hand-rolled copy.
export { campaignSearch } from "./campaignSearch";

export const campaignRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/projects/$projectId",
  validateSearch(search: Record<string, unknown>) {
    const chatId =
      typeof search.chatId === "string" ? search.chatId.trim() : "";
    return {
      chatId: chatId.length > 0 ? chatId : undefined,
    };
  },
  beforeLoad() {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttCampaign,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
